export default "__VITE_ASSET__EbgGBjIN__"